import {
  useQueryClient,
  useQuery,
  useMutation,
  keepPreviousData,
} from "@tanstack/react-query";
import { errorMessage, successMessage } from "../../../utils/helper";
import {
  getSyncScheduledList,
  updateScheduledSync,
  deleteScheduledSync,
} from "../api/PosSyncApi";
import qs from "qs";
import moment from "moment";

const scheduledSyncListKeys = {
  all: ["scheduledSync"],
  lists: () => [...scheduledSyncListKeys.all, "lists"],
  productslist: (filters) => [...scheduledSyncListKeys.lists(), filters],
};

export const useScheduledSyncListQueries = ({
  pagination,
  sorting,
  debouncedText,
  selectedDate,
  selectedStatus,
  selectedCategory,
  selectedSubCategory,
  resetDeleteInfo,
}) => {
  const queryClient = useQueryClient();
  let params = {};

  if (debouncedText) {
    params = { ...params, search: debouncedText };
  }
  if (selectedCategory?.length > 0) {
    params = {
      ...params,
      category_id: selectedCategory?.map((item) => item.id),
    };
  }
  if (selectedSubCategory?.length > 0) {
    params = {
      ...params,
      sub_category_id: selectedSubCategory?.map((item) => item.id),
    };
  }
  if (selectedDate) {
    params = {
      ...params,
      scheduled_date: moment(selectedDate).format("YYYY-MM-DD"),
    };
  }
  if (selectedStatus !== "") {
    params = { ...params, status: selectedStatus };
  }
  if (sorting?.length > 0) {
    const sortByParams = sorting.reduce(
      (obj, item) =>
        Object.assign(obj, { [item.id]: item.desc ? "desc" : "asc" }),
      {},
    );
    params = {
      ...params,
      sort: sortByParams,
    };
  }

  const query = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: true }),
  };

  //list useQueryClient
  const listQuery = useQuery({
    queryKey: scheduledSyncListKeys.productslist({ query, pagination }),
    queryFn: () => getSyncScheduledList({ query, pagination }),
    placeholderData: keepPreviousData,
    enabled: true,
  });

  const updateSheduledDate = useMutation({
    mutationFn: updateScheduledSync,
    onSuccess: ({ success, message }) => {
      success ? successMessage(message) : errorMessage(message);
      queryClient.invalidateQueries({
        queryKey: scheduledSyncListKeys.lists(),
      });
    },
    onError: (error) =>
      errorMessage(
        error.response.data?.message || "Scheduled sync update failed",
      ),
  });

  const removeScheduledSync = useMutation({
    mutationFn: deleteScheduledSync,
    onError: (error) => {
      errorMessage(error?.response?.data);
    },
    onSuccess: (res, variables) => {
      if (res.success) {
        queryClient.invalidateQueries({
          queryKey: scheduledSyncListKeys.lists(),
        });

        successMessage(res.message);
        resetDeleteInfo();
      } else if (res.success === false) {
        errorMessage(res.message);
      }
    },
  });

  return {
    listQuery,
    updateSheduledDate,
    removeScheduledSync,
  };
};
